import React, {Component} from "react";
import { Bar } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js'
import Schedule from "./schedules/Schedule";
import { getModuleUrl } from "../../moduleConfig";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import { clearAppStoragePreservingTheme, getThemeColor } from "../../theme/branding";
Chart.register(...registerables)

class Dashboard extends Component{

    state = {
        
        labels :[],
        data : []
      }

      componentDidMount(){
        this.refreshToken();
        this.getStudents();
      }

      async refreshToken () {
        try{
            var token = await axios.get('token');
            if(token.status === 200)
            {
                var user = (token.data.data);
                localStorage.setItem("user", JSON.stringify(user));
            }
            else{
                axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
                clearAppStoragePreservingTheme();
                window.location.replace(getModuleUrl("stat", "login"))
            }
        }catch(error) {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            clearAppStoragePreservingTheme();
            window.location.replace(getModuleUrl("stat", "login"))
        }
    }

      async getStudents(){
        var students = await axios.get('students/limit');

        if(students.status === 200)
        {
            var labels = [], data = [];
            students.data.map((student) => {
                labels.push((student.matricule || "") + " " + student.user.last_name);
                data.push(student.purcent?.toFixed(1) );
            })
            this.setState({
                labels : labels,
                data : data
            })
        }
      }

      handleCheck(val) {
        var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
         return  permissions.some(item => val === item.permission);
     }

    render(){
        const dashboardAccent = getThemeColor();
        const bestScore = this.state.data.length ? Math.max(...this.state.data.map(value => Number(value || 0))) : 0;
        const average = this.state.data.length ? (this.state.data.reduce((sum, value) => sum + Number(value || 0), 0) / this.state.data.length).toFixed(1) : "-";
        var data = {
            labels: this.state.labels,
            datasets: [
            {
                label: 'points',
                backgroundColor: this.state.data.map((_, index) => index % 2 === 0 ? dashboardAccent : `${dashboardAccent}99`),
                borderColor: 'transparent',
                borderRadius: 9,
                borderSkipped: false,
                data: this.state.data
            }
            ],
        }
        return(
            <div className="ev-dashboard ev-dashboard--learning">
                <div className="learning-hero">
                    <div className="ev-dashboard__heading">
                        <span className="ev-dashboard__eyebrow">Pulse pédagogique</span>
                        <h1 className="ev-dashboard__title">Le rythme de <em>l'apprentissage</em></h1>
                        <p className="ev-dashboard__subtitle">Performances, progression et emploi du temps dans un espace de pilotage vivant.</p>
                    </div>
                    <div className="ev-dashboard__actions d-none">
                        <button type="button" className="ev-button ev-button--secondary ev-button--small dropdown-toggle">
                            <span data-feather="calendar"></span>
                            Année encours
                        </button>
                    </div>
                </div>
                <div className="learning-kpis">
                    <article><FeatherIcon icon="users" /><div><strong>{this.state.data.length}</strong><span>élèves suivis</span></div></article>
                    <article><FeatherIcon icon="activity" /><div><strong>{average}%</strong><span>moyenne actuelle</span></div></article>
                    <article><FeatherIcon icon="award" /><div><strong>{bestScore.toFixed(1)}%</strong><span>meilleure progression</span></div></article>
                </div>
                <section className={ this.handleCheck("Profil admin") == true ? "ev-dashboard__panel learning-performance" : "d-none"}>
                <div className="ev-dashboard__panel-head"><div><span className="ev-dashboard__eyebrow">Performance</span><h2>Les élèves à suivre</h2></div><span className="learning-performance__badge">Score en points</span></div>
                {
                    data.labels.length > 0 && (
                        <Bar
                            data={data}
                            options={{
                            responsive: true, maintainAspectRatio: false,
                            scales: { y: { beginAtZero: true, max: 100, grid: { color: `${dashboardAccent}14` } }, x: { grid: { display: false } } },
                            plugins: {
                                title: {
                                    display: true,
                                    text: "12 premiers élèves"
                                },
                                legend: {
                                    display: true,
                                    position: "bottom"
                                }
                            }
                            }}
                        />
                    )
                }
                </section>

                <section className="learning-schedule">
                    <div className="learning-schedule__intro"><div><span className="ev-dashboard__eyebrow">Aujourd'hui & demain</span><h2>Le tempo de l'école</h2></div><p>L'horaire complet respire sur toute la largeur, pour lire les journées et les classes sans perdre le fil.</p><FeatherIcon icon="calendar" size="36" /></div>
                    <div className="learning-schedule__content"><Schedule /></div>
                </section>
            </div>
        )
    }
}
export default Dashboard;
